import { Route, Routes } from "react-router-dom";
import { Navigate } from "react-router";
import SignUpConfirm from "./Pages/SignUp/SignUpConfirm";
import Login from "./Pages/Login/Login";
import NewPasswordRequired from "./Pages/NewPasswordRequired/NewPasswordRequired";
import SignUp from "./Pages/SignUp/SignUp";
import ForgotPassword from "./Pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./Pages/ForgotPassword/ResetPassword";
import SignUpOnboarding from "./Pages/SignUp/SignUpOnboarding/SignUpOnboarding";
import OrganizationProfile from "./Pages/Organizations/OrganizationProfile/OrganizationProfile";
import HomePage from "./Pages/HomePage/HomePage";
import AIPolicyPage from "./Pages/AIPolicyPage/AIPolicyPage";

const AuthRoutes = () => (
  <Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/home" element={<HomePage />} />
    <Route path="/ai-policy" element={<AIPolicyPage />} />
    <Route path="/login" element={<Login />} />
    <Route path="/measure/login" element={<Login entry="measure" />} />
    <Route path="/measure/forgot-password" element={<ForgotPassword cognitoPool="measureOperator" />} />
    <Route path="/measure/reset-password" element={<ResetPassword />} />
    <Route path="/new-password-required" element={<NewPasswordRequired />} />
    <Route path="logout" element={<Navigate to="/" />} />
    <Route path="signup" element={<SignUp />} />


    <Route
      path="confirm-signup"
      element={<SignUpConfirm />}
    />
    <Route path="forgot-password" element={<ForgotPassword />} />
    <Route path="reset-password" element={<ResetPassword />} />
    <Route path="onboarding" element={<SignUpOnboarding />} />
    <Route
      path="/organizations/:organizationId/profile"
      element={<OrganizationProfile />}
    />
    {/* Avoid 404 flash during sign-out when app briefly sits on a protected path */}
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default AuthRoutes;
